import { Injectable } from '@angular/core';

import { IndiceModeType } from '@enums/indice-mode-type.enum';
import { Partition } from '@classes/simulation/partition';

@Injectable({
    providedIn: 'root'
})
export class FormatService {

    constructor() { }

    formatCursor(value: number, mode: string): string {
        switch(mode) {
            case IndiceModeType.ac:
                return this.localiseNumber(value);
            case IndiceModeType.amount:
                return this.formatAmount(value);
            default:
                return this.formatPercent(value);
        }
    }

    formatAmount(value: number, mode: string = 'rounded', base?: number, doesShowCurrency = true): string {
        const currency = doesShowCurrency ? ' €' : '';

        if(value == null || isNaN(value)) {
            return "";
        }

        switch(mode) {
            case 'auto' :
                return this.formatAuto(value) + currency;
            case 'fixed' :
                return this.formatFixe(value, base);
            case 'rounded':
            default :
                return this.localiseNumber(Math.round(value)) + currency;
        }
    }

    formatPercent(value: number, offset = 0): string {
        if(value == null || isNaN(value) || isNaN(offset)) {
            return "";
        }

        return this.localiseNumber(this.precision(((value + offset) * 100), 2)) + " %";
    }

    stringToFloat(value: string): number {
        if(value == null || value === "") {
            return null;
        }

        if(typeof value === "number") {
            return value as number;
        }

        return parseFloat(value.toString().replace(/[.]/g, "").replace(/[,]/, "."));
    }

    precision(number: number, precision: number): number {
        if(number == null || isNaN(number)) {
            return 0;
        }

        const factor = Math.pow(10, precision);
        return Math.round(number * factor) / factor;
    }

    partitionsArrayToTree(partitions: Partition[], parent?: Partition): Partition[] {
        const treePartitions: Partition[] = partitions.filter(p => p.parentCode == null);

        if(!parent) {
            treePartitions.map(p => {
                this.partitionsArrayToTree(partitions, p);
            });
        } else {
            const childrenArray = partitions.filter(p => p.parentCode === parent.partitionDetails.code);

            if(childrenArray.length > 0) {
                parent['partitions'] = childrenArray;

                childrenArray.forEach(child => {
                    this.partitionsArrayToTree(partitions, child);
                });
            }
        }

        return treePartitions;
    }

    // Calculate the shorten value and add corresponding symbol
    private formatAuto(value: number): string {
        if(Math.abs(value) < 1000) {
            return this.precision(value, 2).toString();
        }

        const symbols = ["K", "M", "B"];
        let i = 0;

        while (Math.abs(value) >= 1000 && i < symbols.length) {
            value /= 1000;

            i++;
        }

        return this.formatFixe(value) + " " + symbols[i - 1];
    }

    // Calculate the value multiply by base with " " between thousands
    private formatFixe(value: number, base: number = 1): string {
        return this.localiseNumber(this.precision(value * base, 2));
    }

    private localiseNumber(number: number): string {
        return number.toString().replace(/[.]/, ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        // return number.toLocaleString('de-DE');
    }
}
